export default __webpack_public_path__ + "static/media/TK.5b4bc7ec.svg";